export const ADD_CHITTIE_AUCTION_STARTED = 'ADD_CHITTIE_AUCTION_STARTED';
export const ADD_CHITTIE_AUCTION_COMPLETED = 'ADD_CHITTIE_AUCTION_COMPLETED';
export const ADD_CHITTIE_AUCTION_ERROR = 'ADD_CHITTIE_AUCTION_ERROR';

export const FETCH_CHITTIE_AUCTION_STARTED = 'FETCH_CHITTIE_AUCTION_STARTED';
export const FETCH_CHITTIE_AUCTION_COMPLETED =
  'FETCH_CHITTIE_AUCTION_COMPLETED';
export const FETCH_CHITTIE_AUCTION_ERROR = 'FETCH_CHITTIE_AUCTION_ERROR';

export const ADD_AUCTION_PAYMENT_STARTED = 'ADD_AUCTION_PAYMENT_STARTED';
export const ADD_AUCTION_PAYMENT_COMPLETED = 'ADD_AUCTION_PAYMENT_COMPLETED';
export const ADD_AUCTION_PAYMENT_ERROR = 'ADD_AUCTION_PAYMENT_ERROR';

export const UPDATE_AUCTION_STARTED = 'UPDATE_AUCTION_STARTED';
export const UPDATE_AUCTION_COMPLETED = 'UPDATE_AUCTION_COMPLETED';
export const UPDATE_AUCTION_ERROR = 'UPDATE_AUCTION_ERROR';

export const FETCH_MINUTES_STARTED = 'FETCH_MINUTES_STARTED';
export const FETCH_MINUTES_COMPLETED = 'FETCH_MINUTES_COMPLETED';
export const FETCH_MINUTES_ERROR = 'FETCH_MINUTES_ERROR';

export const DELETE_AUCTION_STARTED = 'DELETE_AUCTION_STARTED';
export const DELETE_AUCTION_COMPLETED = 'DELETE_AUCTION_COMPLETED';
export const DELETE_AUCTION_ERROR = 'DELETE_AUCTION_ERROR';



// WEBPACK FOOTER //
// ./src/redux/actionTypes/chittieAuctionActionTypes.js